import React from 'react';
import { CtaButton } from './CtaButton';
import { checkoutUrl, cta } from '../data/content';
export function FinalCta() {
  return <section className="border-t border-night-line bg-night" data-id="element-66" data-mp="vgqwwj1g32gg">
      <div className="mx-auto max-w-3xl px-5 pt-16 text-center sm:px-6 lg:pt-24" data-id="element-67" data-mp="19fgx47jk9i91">
        <h2 className="font-display text-[1.75rem] font-semibold leading-tight tracking-tight text-parchment sm:text-4xl" data-id="element-68" data-mp="15dlv10tt30u7">
          Ten una Palabra de Dios cerca para esos momentos en los que más la necesitas
        </h2>
        <p className="mx-auto mt-5 max-w-xl font-sans text-base leading-relaxed text-parchment/70 sm:text-lg" data-id="element-69" data-mp="1eetrddcrhrln">
          50 tarjetas, una cajita y 4 bonos para que Su Palabra te acompañe en casa y
          durante todo el día.
        </p>

        <div className="mx-auto mt-9 max-w-md" data-id="element-70" data-mp="1o4n1sb1640ob">
          <CtaButton size="block" href={checkoutUrl} data-id="element-71" data-mp="2233ag7ilc193">
            {cta.label}
          </CtaButton>
          <p className="mt-3 font-sans text-xs text-parchment/60 sm:text-sm" data-id="element-72" data-mp="1x51pfh1ltruz">
            {cta.microcopy}
          </p>
        </div>
      </div>
    </section>;
}